import { createSelector, createFeatureSelector } from '@ngrx/store';
import { buildListMessage } from 'src/admin-app/utilities/list-filtering/list-message';
import {
	AdminUsersState,
	adminUserFeatureKey,
	adminUsersAdapter,
} from './admin-user.reducer';

export const getAdminUsersState = createFeatureSelector<AdminUsersState>(
	adminUserFeatureKey
);

const { selectEntities } = adminUsersAdapter.getSelectors();

export const getListLoadingStatus = createSelector(
	getAdminUsersState,
	(state) => !state.isListInitialized || state.isLoadingList
);

export const getDetailLoadingStatus = createSelector(
	getAdminUsersState,
	(state) => state.isLoadingDetail
);

const getAdminUserCount = createSelector(
	getAdminUsersState,
	(state) => state.results?.length
);

export const getError = createSelector(
	getAdminUsersState,
	(state) => state.error
);

export const getAllAdminUsers = createSelector(
	getAdminUsersState,
	(state) => state.results
);

export const getAllAdminUserEntities = createSelector(
	getAdminUsersState,
	selectEntities
);

export const getListMessage = createSelector(
	getError,
	getListLoadingStatus,
	getAdminUserCount,
	(error, isLoading, resultCount) =>
		buildListMessage(error, isLoading, { resultCount })
);

export const getIsSaving = createSelector(
	getAdminUsersState,
	(state) => state.isSaving
);

export const getSelectedAdminUserId = createSelector(
	getAdminUsersState,
	(state) => state.selectedAdminUserId
);

export const getSelectedAdminUser = createSelector(
	getAllAdminUserEntities,
	getSelectedAdminUserId,
	(adminEntities, adminId) => adminEntities[adminId]
);

export const getCloseAfterSaving = createSelector(
	getAdminUsersState,
	(state) => !state.shouldStayOnPage
);

export const getListArgs = createSelector(
	getAdminUsersState,
	(state: AdminUsersState) => state.listArgs
);
